/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import McQueryResult from './McQueryResult';

/**
 * The McOutputCmsMc model module.
 * @module model/McOutputCmsMc
 * @version 1.0
 */
class McOutputCmsMc {
    /**
     * Constructs a new <code>McOutputCmsMc</code>.
     * @alias module:model/McOutputCmsMc
     */
    constructor() { 
        
        McOutputCmsMc.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>McOutputCmsMc</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/McOutputCmsMc} obj Optional instance to populate.
     * @return {module:model/McOutputCmsMc} The populated <code>McOutputCmsMc</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new McOutputCmsMc();

            if (data.hasOwnProperty('mc')) {
                obj['mc'] = McQueryResult.constructFromObject(data['mc']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/McQueryResult} mc
 */
McOutputCmsMc.prototype['mc'] = undefined;






export default McOutputCmsMc;

